<script>
import Page from '@/components/elements/Page';
export default {
    name: 'InternationalQRCode',
    components: {
        Page

    },
    data() {
        return {
            vwAlgemeen: false,
            vwCovidBewijsMaken: false,
            vwInternational: false,
            vwProblemen: false,
            vwOverige: false,
            srcAlgemeen: 'assets/img/artwork/chevron-down.svg',
            srcCovidBewijsMaken: 'assets/img/artwork/chevron-down.svg',
            srcInternational: 'assets/img/artwork/chevron-down.svg',
            srcProblemen: 'assets/img/artwork/chevron-down.svg',
            srcOverige: 'assets/img/artwork/chevron-down.svg'
        }
    },
    methods: {
        onAlgemeenSelect() {
            this.vwAlgemeen = !this.vwAlgemeen;
            this.vwAlgemeen === true ? this.srcAlgemeen = 'assets/img/artwork/chevron-up.svg' : this.srcAlgemeen = 'assets/img/artwork/chevron-down.svg';
        },
        onCovidBewijsMakenSelect() {
            this.vwCovidBewijsMaken = !this.vwCovidBewijsMaken;
            this.vwCovidBewijsMaken === true ? this.srcCovidBewijsMaken = 'assets/img/artwork/chevron-up.svg' : this.srcCovidBewijsMaken = 'assets/img/artwork/chevron-down.svg';
        },
        onInternationalSelect() {
            this.vwInternational = !this.vwInternational;
            this.vwInternational === true ? this.srcInternational = 'assets/img/artwork/chevron-up.svg' : this.srcInternational = 'assets/img/artwork/chevron-down.svg';
        },
        onProblemenSelect() {
            this.vwProblemen = !this.vwProblemen;
            this.vwProblemen === true ? this.srcProblemen = 'assets/img/artwork/chevron-up.svg' : this.srcProblemen = 'assets/img/artwork/chevron-down.svg';
        },
        onOverigeSelect() {
            this.vwOverige = !this.vwOverige;
            this.vwOverige === true ? this.srcOverige = 'assets/img/artwork/chevron-up.svg' : this.srcOverige = 'assets/img/artwork/chevron-down.svg';
        }
    },
    created() {
        document.title = 'Frequently asked questions';
    }
}
</script>

<template>
    <Page class="home" :displayBackButton=false>
        <div class="section">
            <div class="section-block" style="width:450px">
                <div>
                    <div style="float: left"><h2>General</h2></div>
                    <div style="float: right"><img :src="this.srcAlgemeen" width="24" height="24" @click="onAlgemeenSelect()" style="cursor: pointer;" /></div>
                </div>
                <div v-if="this.vwAlgemeen">
                <br><br>
                <p><br>
                <b>What is the Digital COVID Certificate (DCC)?</b><br>
                The Digital COVID Certificate (DCC for short) is the digital or paper proof that someone has been vaccinated against COVID-19.
                </p>
                <p>
                    Curaçao has a Curaçao DCC that is also accepted within the European Union. People who have been vaccinated in Curaçao can apply for their DCC via <a href="https://curacaohealthapp.com" target="_blank">www.curacaohealthapp.com</a> and this proof is created in the form of a QR code.
                </p>

                <p>
                    All countries decide for themselves which DCC or COVID-19 proofs are accepted upon entry into the country. Each country also determines the rules and conditions that passengers must adhere to. If you are traveling to an EU country, you can check via <a href="https://reopen.europa.eu/en" target="_blank">Re-open EU</a> whether you can use your DCC QR code locally.
                </p><br>

                <p>
                <b>Where is a Digital COVID Certificate (DCC) needed?</b><br>
                If you want access to, for example, a high-risk activity, facility or event on Curaçao or if you want to travel within the Kingdom or a country within the European Union (EU), you may have to prove that you have been tested negative or are vaccinated or have already had COVID-19. To facilitate this process, a digital means of proof also known as Digital COVID Certificate (DCC), has been introduced.
                </p>
                <p>
                    When digitizing the means of evidence, a digital DCC for vaccinations will be started in Curaçao. At a later stage, the test results and the COVID-19 recovery evidence will also be available digitally.
                </p>

                <p>
                    To gain access to certain events and locations on Curaçao, a DCC will also be requested along with a valid ID. As soon as this is possible, more information will be provided via the Government of Curaçao and also the organizer.
                </p><br>

                <p>
                <b>How long is my DCC valid for? Can I use it multiple times?</b><br>
                Validity of our DCC is linked to how long the protection of the COVID-19 vaccination will remain valid. When this is known, the validity of the DCC QR code is adjusted accordingly. Until this is known, the vaccination certificate is valid indefinitely. Officially, a vaccination certificate is valid from 14 days after the last vaccination.
                </p><br>

                <p>
                <b>How is a DCC checked?</b><br>
                Checking a DCC is done with the <a href="https://apps.apple.com/nl/app/dcc-scanner-app/id1572642859" target="_blank">Cross border DCC Scanner</a>. With this app, a checker checks the validity of the Digital COVID Certificate (DCC) at the entrance by scanning the QR code. You can show your QR code hardcopy on an A4 sheet or have it digitally with you.
                </p><br>

                <p>
                <b>What information is in my QR code?</b><br>
                The same rules apply to Curaçao as agreed within Europe. This means that when scanning the DCC QR code, the inspector can see the following information:
                </p>
                <p>
                    <b>International vaccination data</b>
                    <ul style="margin-left: 40px;">
                    <li>(a) Last name, first name(s) and date of birth;</li>
                    <li>(b) Pathogen: COVID-19;</li>
                    <li>(c) Vaccine type, vaccine and vaccine manufacturer;</li>
                    <li>(d) Number of doses in a series/total number of doses;</li>
                    <li>(e) Vaccination date;</li>
                    <li>(f) Country or EU Member State that was vaccinated;</li>
                    <li>(g) Issuer certificate and a certificate code.</li>
                    </ul>
                </p><br>

                <p>
                <b>What information does the certificate contain? Is that data safe?</b><br>
                The information on the digital EU-covid certificate is limited to:<br>
                    <ul style="margin-left: 40px;">
                    <li>(a) Your first name and last name;</li>
                    <li>(b) Your date of birth;</li>
                    <li>(c) Date of issue;</li>
                    <li>(d) Vaccine/test/recovery information;</li>
                    <li>(e) A unique identifier.</li>
                    </ul>
                </p>
                <p>
                   This data remains on the certificate and is not saved or retained when the certificate is verified through QR code or human checks.
                </p>

                <p>
                   All other health data remains in the hands of the national authority that issued the EU-covid digital certificate.
                </p><br>

                <p>
                <b>I have a valid DCC, but have complaints or have to go into quarantine. Is my DCC still valid?</b><br>
                Do you have complaints such as a cold, cough or shortness of breath? Stay at home. Even if you are (fully) vaccinated.<br>
                If you have tested negative, you must still be tested again at the GGD (Public Health service) if you have complaints. A negative test result means that you did not have COVID-19 at the time of testing. It is possible that you later became infected.
                </p><br>

                <p>
                <b>Do I have to keep my unique combination code?</b><br>
                Yes, the unique combination code is linked to your registration for your DCC, which is shown with a QR Code. You should keep this well.
                </p>
                <p>
                    Lost your PDF? You can use your unique combination code to download your DCC QR code via <a href="https://curacaohealthapp.com" target="_blank">www.curacaohealthapp.com</a>. Click on ‘Create vaccination certificate’, enter your unique combination code and follow the instructions.
                </p><br>

                <p>
                <b>How do I save my Curaçao DCC QR code?</b><br>
                You can print out your DCC QR code or save it digitally on your phone or on your computer.
                </p></div>
                <br><br>
               <div>
                    <div style="float: left;width: 90%"><h2>Make Covid certificate</h2></div>
                    <div style="float: right"><img :src="this.srcCovidBewijsMaken" width="24" @click="onCovidBewijsMakenSelect()" height="24" style="cursor: pointer;" /></div><br><br>
                </div>
                <div v-if="this.vwCovidBewijsMaken">
                <br>
                <p><br>
                <b>When can I apply for a Curaçao DCC?</b><br>
                To apply for a Curaçao DCC, you must be fully vaccinated in Curaçao. You have been fully vaccinated 14 days after your second vaccination.
                </p><br>

                <p>
                <b>I have been vaccinated abroad. Can I apply for a Curaçao DCC?</b><br>
                No. Only people who have been vaccinated locally are eligible for a Curaçao DCC QR code.
                </p><br>

                <p>
                <b>Can I create a proof for someone else?</b><br>
                Applying for and obtaining a Curaçao DCC QR code is the responsibility of each vaccinated individual. Parents can create the DCC for their fully vaccinated minor children through the registration process.
                </p>
                 <p>
                    If necessary, there is the possibility to authorize another adult. Please contact the helpdesk: <a href="mailto:helpdesk@curacaohealthapp.com">helpdesk@curacaohealthapp.com</a>
                </p><br><br>
                </div>
                <div>
                    <div style="float: left;width: 90%"><h2>International travel with Curaçao Health App</h2></div>
                    <div style="float: right"><img :src="this.srcInternational" width="24" @click="onInternationalSelect()" height="24" style="cursor: pointer;" /></div><br><br><br><br><br><br>
                </div>
                <div v-if="this.vwInternational">
                <br>
                <p>
                <b>Can I use my Curaçao DCC abroad?</b><br>
                A Curaçao DCC automatically has an international EU-DCC key. This means that your Curaçao DCC can currently be used in all countries within the Kingdom and the EU Member States.
                </p>
                 <p>
                    Before you travel, check <a href="https://reopen.europa.eu/en" target="_blank">Re-open EU</a> to check whether you can use your Curaçao DCC locally. You can also use the EU DCC QR code for events in the country you are traveling to. You must comply with the local rules for this.
                </p><br>

                <p>
                <b>I am not vaccinated. Can I travel internationally?</b><br>
                Yes, that is possible with a negative test result or if you have already had COVID-19 and have 1 vaccination. For the Curaçao DCC via <a href="https://curacaohealthapp.com" target="_blank">www.curacaohealthapp.com</a> there is not yet a possibility to create a QR code for test proof or recovery proof.
                </p>
                 <p>
                    When travelling, use the official papers to present your test certificate or recovery certificate to the border security. Note: Within Europe it is possible to show proof of test or recovery proof with a QR Code. The requirements you must meet to be eligible for creating this QR Code differ per country.
                </p><br>

                <p>
                <b>I am in possession of an EU DCC. Can I go to an event in Curaçao with my EU DCC?</b><br>
                Yes, that's possible. The same domestic rules apply to all Europeans as they also apply to the Curaçao population. When the proofs meet the EU rules, you can also go to events in Curaçao as a European.
                </p><br>
                </div>
               <div>
                    <div style="float: left;width: 90%"><h2>Problems</h2></div>
                    <div style="float: right"><img :src="this.srcProblemen" width="24" @click="onProblemenSelect()" height="24" style="cursor: pointer;" /></div><br><br><br>
                </div>
                <div v-if="this.vwProblemen">
                <p>
                <b>Are you unable to create a Curaçao DDC via the website?</b><br>
                Send an email to <a href="mailto:helpdesk@curacaohealthapp.com">helpdesk@curacaohealthapp.com</a> or call the helpdesk to make an appointment at +5999 433-3111. The helpdesk can be reached by telephone from Monday to Friday from 8:00 am to 3:00 pm.
                </p><br>

                <p>
                <b>My DCC QR code has been scanned but shows a red screen. What should I do?</b><br>
                A green screen is always required for access. A red screen indicates that you do not have valid proof and unfortunately you will not be admitted.
                </p>

                 <p>
                    Red screen in Curaçao? It is also possible that the COVID-19 measures on Curaçao have been adjusted. Check <a href="https://gobiernu.cw" target="_blank">www.gobiernu.cw</a> for the rules and validity of your DCC in Curaçao.
                </p>

                 <p>
                    Does a red screen keep appearing even though you do have valid proof? Please contact the helpdesk via <a href="mailto:helpdesk@curacaohealthapp.com">helpdesk@curacaohealthapp.com</a> or telephone number +5999 433-3111. The helpdesk can be reached by telephone from Monday to Friday from 8:00 am to 3:00 pm.
                </p>

                 <p>
                    A red screen at the border? It is also possible that the COVID-19 measures in the country you are visiting are different than in Curaçao. Check <a href="https://reopen.europa.eu/en" target="_blank">Re-open EU</a> for the rules and validity of the Curaçao DCC in the EU Member States and the Kingdom.
                </p><br><br>
                </div>
                 <div>
                    <div style="float: left;width: 90%"><h2>Other</h2></div>
                    <div style="float: right"><img :src="this.srcOverige" width="24" @click="onOverigeSelect()" height="24" style="cursor: pointer;" /></div><br><br><br>
                </div>
                <div v-if="this.vwOverige">
                <p>
                <b>I am organizing an event soon and want to scan the DCC QR code at the entrance. How do I do this?</b><br>
                Event organizers and venues can download the <a href="https://apps.apple.com/nl/app/dcc-scanner-app/id1572642859" target="_blank">Cross border DCC Scanner app</a> on a mobile phone or tablet. The Curaçao government will indicate as soon as possible when locals with the Curaçao DCC can use the scanner app.
                </p>

                <p>
                    Click on the following links to download the app from the iOS store or Google store:<br>
                    <b>iOS Store:</b> <a href="https://apps.apple.com/nl/app/dcc-scanner-app/id1572642859" target="_blank">DCC Cross border DCC Scanner</a><br>
                    <b>Google Play:</b> <a href="https://play.google.com/store/apps/details?id=nl.rijksoverheid.dcbs.verifier&hl=en&gl=US" target="_blank">DCC Cross border Scanner app NL</a>
                </p><br>
                </div>
            </div>
        </div>
    </Page>
</template>

<style lang="scss">
@import "@/styles/variables/index";

.home {

    .home__section {
        margin-bottom: $length-l;
    }

    .UserConsent {
        margin: $grid-x6 0 $length-s 0;
    }

    .ErrorLabel {
        margin-bottom: $length-s;
    }
}
</style>
